<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon cf-dlg-icon--green">
      <mat-icon>payment</mat-icon>
    </div>
    <div class="cr-header-text">
      <h2 class="cf-dlg-title">Cobro de cuotas</h2>
      <p class="cf-dlg-subtitle" *ngIf="subtitle">{{ subtitle }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="close()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="!ready" message="Cargando cobros…"></app-loading-state>
  <app-loading-state *ngIf="ready && saving" [message]="savingMessage"></app-loading-state>

  <ng-container *ngIf="ready && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="cr-empty cr-empty--error">
        <mat-icon>error</mat-icon>
        <span>No se pudieron cargar los cobros del crédito.</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="retry()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="ready && !saving && !loadError">
    <div class="cf-dlg-body cr-body">

      <div class="cr-summary">
        <div class="cr-summary__left">
          <div class="cr-summary__icon"><mat-icon>account_balance_wallet</mat-icon></div>
          <div>
            <span class="cr-summary__label">Importe pendiente</span>
            <span class="cr-summary__amount">{{ pendingAmount | number:'1.2-2' }} €</span>
            <span class="cr-summary__hint">
              Inicial {{ initialAmount | number:'1.2-2' }} € · Cobrado {{ collectedAmount | number:'1.2-2' }} €
            </span>
          </div>
        </div>
        <div class="cr-summary__actions" *ngIf="!editing && pendingAmount > 0">
          <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="assignPending()">
            <mat-icon>check</mat-icon> Asignar pendiente
          </button>
        </div>
      </div>

      <div class="cr-section">
        <span class="cf-dlg-section__label">
          {{ editing ? 'Editar cobro' : 'Nuevo cobro' }}
          <button *ngIf="editing" type="button" class="cr-link" (click)="cancelEdit()">Cancelar edición</button>
        </span>

        <div class="cr-grid">
          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingDate">
            <app-date [control]="control('fecha')" [config]="{ label: 'Fecha', required: true }"></app-date>
            <div class="cf-field__error" *ngIf="submitted && missingDate"><mat-icon>error</mat-icon> Indica la fecha</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingConcept">
            <app-field [control]="control('concepto')" [config]="{ label: 'Concepto', type: 'text', required: true, maxLength: 100 }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && missingConcept"><mat-icon>error</mat-icon> Indica el concepto</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && invalidCapital">
            <app-field [control]="control('importeCapital')" [config]="{ label: 'Importe capital', type: 'number', required: true, inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
            <div class="cf-field__error" *ngIf="submitted && invalidCapital"><mat-icon>error</mat-icon> {{ isEmployee ? 'Indica el capital' : 'Debe ser mayor que cero' }}</div>
          </div>

          <div>
            <app-field [control]="control('intereses')" [config]="{ label: 'Intereses', type: 'number', inputmode: 'decimal', step: 0.01, suffix: '€' }"></app-field>
          </div>

          <div *ngIf="!isEmployee">
            <app-autocomplete [control]="control('tax')" [config]="{ label: 'Retención sobre intereses', placeholder: 'Sin retención', options: taxes, strict: true }">
            </app-autocomplete>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingActivity">
            <app-autocomplete [control]="control('activity')" [config]="{ label: 'Actividad', placeholder: 'Seleccionar actividad…', options: activities, required: true, autoSelectSingle: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && missingActivity"><mat-icon>error</mat-icon> Selecciona la actividad</div>
          </div>

          <div class="cf-field--required" [class.cf-field--invalid]="submitted && missingBankAccount">
            <app-autocomplete [control]="control('bankAccount')" [config]="{ label: 'Cuenta bancaria', placeholder: 'Seleccionar cuenta…', options: bankAccounts, required: true, autoSelectSingle: true, strict: true }">
            </app-autocomplete>
            <div class="cf-field__error" *ngIf="submitted && missingBankAccount"><mat-icon>error</mat-icon> Selecciona la cuenta bancaria</div>
          </div>

          <div *ngIf="showProjects">
            <app-autocomplete [control]="control('project')" [config]="{ label: 'Proyecto', placeholder: 'Sin proyecto', options: projects, strict: true }">
            </app-autocomplete>
          </div>

          <div *ngIf="showExpenseProjectTypes">
            <app-autocomplete [control]="control('expenseProjectType')" [config]="{ label: 'Tipo de gasto del proyecto', placeholder: 'Sin tipo', options: expenseProjectTypes, strict: true }">
            </app-autocomplete>
          </div>
        </div>
      </div>

      <div class="cr-section">
        <span class="cf-dlg-section__label">
          Cobros registrados
          <span class="cr-section__hint" *ngIf="yearHint">{{ yearHint }}</span>
        </span>

        <div class="cr-empty" *ngIf="!items.length">
          <mat-icon>info</mat-icon>
          <span>Todavía no hay cobros registrados{{ yearHint ? ' en este ejercicio' : '' }}.</span>
        </div>

        <div class="cr-rows" *ngIf="items.length">
          <div class="cr-row" *ngFor="let item of items; trackBy: trackByUid" [class.cr-row--editing]="editing?.uid === item.uid">
            <div class="cr-row__main">
              <div class="cr-row__amount">{{ (item.importeCapital || 0) | number:'1.2-2' }} €</div>
              <div class="cr-row__meta" [title]="itemMeta(item)">{{ itemMeta(item) }}</div>
            </div>
            <div class="cr-row__date">{{ itemDate(item) }}</div>
            <div class="cr-row__actions">
              <button mat-icon-button class="cr-row__btn" (click)="startEdit(item)" title="Editar" aria-label="Editar cobro">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-icon-button class="cr-row__btn cr-row__btn--danger" (click)="remove(item)" title="Eliminar" aria-label="Eliminar cobro">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="close()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save()" [disabled]="saving">
        <mat-icon>{{ editing ? 'save' : 'check_circle' }}</mat-icon> {{ editing ? 'Guardar cambios' : 'Cobrar' }}
      </button>
    </div>
  </ng-container>
</div>
